import { Box } from 'braid-design-system';
import React, { type ReactNode } from 'react';

import ButtonWrapper from 'src/components/ButtonWrapper/ButtonWrapper';
import ConditionalWrapper from 'src/components/ConditionalWrapper/ConditionalWrapper';

interface Props {
  enabled: boolean;
  destination: string;
  children: ReactNode;
  htag: string;
}

const Tile = ({ enabled, destination, children, htag }: Props) => (
  <Box
    boxShadow="borderNeutralLight"
    padding="medium"
    borderRadius="standard"
    height="full"
  >
    <ConditionalWrapper
      condition={enabled}
      wrapper={(childNode: ReactNode) => (
        <ButtonWrapper
          htag={htag}
          onClick={() => window?.location.assign(destination)}
        >
          {childNode}
        </ButtonWrapper>
      )}
    >
      {children}
    </ConditionalWrapper>
  </Box>
);

export default Tile;
